import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface LayoutState {
  showDrawer: boolean
}

const initialState: LayoutState = {
  showDrawer: false,
}

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setShowDrawer: (state, action: PayloadAction<boolean>) => {
      state.showDrawer = action.payload
    },
  },
})

export const { setShowDrawer } = layoutSlice.actions

export default layoutSlice.reducer
